import { hostEditMutation } from "@/admin/hosts/hostQuery.ts";
import type { HostWithStorage } from "@/admin/hosts/hostsWithStorageQuery.ts";
import { HvOs } from "@/admin/hosts/HvOs.tsx";
import { ModalHeaderBlock } from "@/admin/hosts/ModalHeaderBlock.tsx";
import { StatusBadge } from "@/admin/hosts/StatusBadge.tsx";
import { EditableButton } from "@/components/forms/EditableButton.tsx";
import { FormField } from "@/components/forms/FormField.tsx";
import { WSelect } from "@/components/forms/WSelect.tsx";
import { WModal, WModalContent } from "@/components/modal/WModal.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import type { HostOsType } from "@warrenio/api-spec/spec.oats.gen";
import { useState } from "react";

interface OsType {
    id: HostOsType;
    title: string;
}

const osItems: OsType[] = [
    { id: "multi", title: "Multi" },
    { id: "linux", title: "Linux" },
    { id: "windows", title: "Windows" },
];

interface OsBadgeModalProps {
    item: HostWithStorage;
}

export function OsBadgeButton(props: OsBadgeModalProps) {
    const { item } = props;
    return (
        <WModal
            button={
                <EditableButton action={undefined}>
                    <HvOs value={item.os} />
                </EditableButton>
            }
        >
            <OsBadgeModalContent {...props} />
        </WModal>
    );
}

function OsBadgeModalContent({ item }: OsBadgeModalProps) {
    const [os, setOs] = useState(item.os);
    const updateMutation = useStandardMutation(hostEditMutation);

    async function onSubmit() {
        await updateMutation.mutateAsync({
            body: {
                uuid: item.uuid,
                os,
            },
            location: item.location,
        });
    }

    return (
        <WModalContent title="Change Hypervisor OS" label="Change" modalAction={async () => await onSubmit()}>
            <ModalHeaderBlock item={item}>
                <StatusBadge item={item} />
            </ModalHeaderBlock>

            <div className="pt-4">
                <FormField isRequired wide headless label="OS">
                    <WSelect
                        isRequired
                        getKey={(item) => item.id}
                        items={osItems}
                        aria-label="Select os"
                        getTextValue={(item) => item.title}
                        valueKey={os}
                        onChange={(item) => setOs(item.id)}
                    >
                        {({ id }) => <HvOs value={id} />}
                    </WSelect>
                </FormField>
            </div>
        </WModalContent>
    );
}
